import { render, staticRenderFns } from "./TransViewCC.vue?vue&type=template&id=cbd6522a&scoped=true"
import script from "./TransViewCC.vue?vue&type=script&lang=js"
export * from "./TransViewCC.vue?vue&type=script&lang=js"
import style0 from "./TransViewCC.vue?vue&type=style&index=0&id=cbd6522a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6522a",
  null
  
)

export default component.exports